import { getInstanceId } from '@va/dashboard/selectors/app';
import { getGlobalFilter, getStepFilter } from '@va/dashboard/selectors/ui';
import { PeriodFilter } from '@va/types/time';
import { Moment } from 'moment';
import { useSelector } from 'react-redux';

export const useCurrentPeriodFilter = <T extends boolean = true>(keepOffset = true, convertToIso: T = true as T) => {
  const { from, until } = useSelector(getGlobalFilter);
  const { period: unit } = useSelector(getStepFilter);
  const websiteId = useSelector(getInstanceId);

  let start: Moment | string = from;
  let end: Moment | string = until;

  if (convertToIso) {
    start = from.toISOString(keepOffset);
    end = until.toISOString(keepOffset);
  }

  return {
    from: start,
    until: end,
    unit,
    websiteId,
  } as PeriodFilter<T extends true ? string : Moment>;
};
